import { render, staticRenderFns } from "./EntityReportPanel.vue?vue&type=template&id=56725367&scoped=true&"
import script from "./EntityReportPanel.vue?vue&type=script&lang=js&"
export * from "./EntityReportPanel.vue?vue&type=script&lang=js&"
import style0 from "./EntityReportPanel.vue?vue&type=style&index=0&id=56725367&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56725367",
  null
  
)

export default component.exports